import mitt from 'mitt'

const emitter = mitt<ApplicationEvents>()

export const useEventEmitter = () => {
  return emitter
}
